module.exports = __webpack_public_path__ + "static/media/10x_logo_white.70916725.svg";